var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideoconference = function SvgVideoconference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M11.928 15.937c2.026 2.028 3.733 2.42 3.733 2.42s.898-1.748 2.11-2.081c.658-.181 2.543.387 4.234 1.155s2.01 1.447 1.995 2.438c-.014.934-.557 2.073-1.285 2.896-.498.563-1.423 1.393-3.461 1.209-2.442-.22-5.936-1.508-9.902-5.446l-.094-.093c-3.937-4.074-5.126-7.57-5.25-9.98-.103-1.994.786-2.861 1.383-3.323.874-.675 2.062-1.157 3.02-1.131 1.015.027 1.697.366 2.412 2.047s1.217 3.544 1.004 4.178c-.392 1.167-2.219 1.97-2.219 1.97s.329 1.68 2.32 3.741",
    clipRule: "evenodd"
  })));
};
export default SvgVideoconference;